import ZusDeclarationPackageApi from '../../../../../api-v2/bookkeeping/zus-declarations-package.js';
import awaitWrap from '../../../../procedures/await-wrap.js';
import notifyError from '../../../../procedures/notify-error';
import notifySuccess from '../../../../procedures/notify-success';
import signDocument from '../../../../procedures/sign-document.js';
import action from '../../../abstract/action.js';
import { ZUS_SIGN_STATUS_VALUES } from '../../../../constants-v2/bookkeeping/zus-declaration';

export default action({
  label: 'Podpisz i wyślij',
  icon: 'SendIcon',
  main: () => false,
  handle: async ({ reloadList, $vs, item, $router }) => {
    $vs.loading();

    const tokenResponse = await axios.post(
      import.meta.env.VITE_SITE_URL + '/zus/packages/' + item.id + '/signer-tokens',
    );

    const asicResponse = await signDocument({
      $vs: $vs,
      format: 'asic',
      document: item.xml,
      token: tokenResponse.data,
    });

    if (!asicResponse) {
      $vs.loading.close();
      return;
    }

    let data = {
      month: item.month,
      year: item.year,
      signed: asicResponse.data.signed,
    };

    try {
      await ZusDeclarationPackageApi.signAndSendToZus({
        zuspackageId: item.id,
        data: data,
      });

      notifySuccess({
        $vs,
        text: 'Zestaw został podpisany i wysłany',
      });

      try {
        await ZusDeclarationPackageApi.getStatus({
          zuspackageId: item.id,
        });
      } catch (error) {
        notifyError({
          $vs,
          text: 'Nie udało się odświeżyć statusu zestawu.',
        });
      }

      awaitWrap(reloadList)();
      
    } catch (error) {
      notifyError({
        $vs,
        text: 'Zestaw nie został podpisany i wysłany',
      });
    }
    $vs.loading.close();
  },
  disabled: (item) => isDisabled(item),
  tooltip: {
    isActive: (item) => isDisabled(item),
    text: 'Zestaw został już wysłany',
    //text: 'Opcja wysyłki do ZUS jest obecnie zablokowana do czasu weryfikacji systemu przez ZUS',
  },
});

function isDisabled(item) {
  if(item?.status === ZUS_SIGN_STATUS_VALUES.ERROR_PACKAGE) {
    return false;
  }

  return item.task_index_package_in_zus !== null;
}
